module.exports = __webpack_public_path__ + "img/Group 4090.2e048a36.png";